import api from '../../api';

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, value);
  });
  return search.toString();
}

const state = {
  summary: null,
  streamsPayload: null,
  loadingSummary: false,
  loadingStreams: false,
  error: null,
};

const getters = {
  summary: (state) => state.summary || {},
  objects: (state) => state.summary?.objects || [],
  streams: (state) => state.streamsPayload?.streams || state.summary?.streams || [],
};

const mutations = {
  setSummary(state, payload) {
    state.summary = payload;
  },
  setStreamsPayload(state, payload) {
    state.streamsPayload = payload;
  },
  setLoadingSummary(state, value) {
    state.loadingSummary = value;
  },
  setLoadingStreams(state, value) {
    state.loadingStreams = value;
  },
  setError(state, value) {
    state.error = value;
  },
};

const actions = {
  async fetchSummary({ commit }, params = {}) {
    commit('setLoadingSummary', true);
    try {
      const query = buildQuery(params);
      const { data } = await api.get(`/api/portal/summary${query ? `?${query}` : ''}`);
      commit('setSummary', data);
      commit('setError', null);
      return data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Не удалось загрузить клиентский портал');
      throw error;
    } finally {
      commit('setLoadingSummary', false);
    }
  },
  async fetchStreams({ commit }, params = {}) {
    commit('setLoadingStreams', true);
    try {
      const query = buildQuery(params);
      const { data } = await api.get(`/api/portal/streams${query ? `?${query}` : ''}`);
      commit('setStreamsPayload', data);
      commit('setError', null);
      return data;
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Не удалось загрузить список трансляций');
      throw error;
    } finally {
      commit('setLoadingStreams', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
